import Swiper from "swiper";
import { clickOn, initTimer, load, getPage } from "../events/events.js";
// Партнери
if(getPage() === 'home'){
	const partners = {
		section: "#partners",
		direction: "horizontal",
		canSwipe: true,
		init: function () {
			const { section } = this;
			this.buttons = [`${section} .prev`, `${section} .next`];
			this.swipers = {
				titles: titles_partners,
				images: images_partners,
				texts: texts_partners,
			};
			document.querySelector(partners.buttons[0])?.classList?.add('canPrev')
			document.querySelector(partners.buttons[1])?.classList?.add('canNext')
			if(this.swipers.images.isBeginning){
				document.querySelector(partners.buttons?.[0])?.classList.remove('canPrev')
			}
			if(this.swipers.images.isEnd){
				document.querySelector(partners.buttons?.[1])?.classList.remove('canNext')
			}
			this.pagination = document.querySelector(`${section} .counter`);
			return (callback)=>{
					callback()
			}
		},
		next: function () {
			if (!this.canSwipe || this.swipers.images.isEnd) return;
			const [delay, anim] = [1000, 1000];
			this.canSwipe = false;
			Object.values(this.swipers).forEach((swiper) => {
				swiper.slides[swiper.realIndex].classList.add("fade-out");
			});
			initTimer(
				"anim",
				() => {
					Object.values(this.swipers).forEach((swiper) => {
						swiper.slides[swiper.realIndex + 1]?.classList.add("fade-in");
						swiper.slideNext();
						swiper.slides[swiper.realIndex - 1]?.classList.remove("fade-out");
						initTimer(
							`anim-in-${[...swiper.hostEl.classList].filter((c) =>
								c.includes("-swiper")
							)}`,
							() => {
								swiper.slides[swiper.realIndex].classList.remove("fade-in");
							},
							delay
						);
					});
					partners.updateCounter.bind(partners)();
					document.querySelector(partners.buttons?.[0])?.classList.add('canPrev')
					if(partners.swipers.images.isEnd){
						document.querySelector(partners.buttons?.[1])?.classList.remove('canNext')
					}else{
						document.querySelector(partners.buttons?.[1])?.classList.add('canNext')
					}
				},
				anim
			);
			initTimer(
				"swipeNext",
				() => {
					this.canSwipe = true;
				},
				delay + anim
			);
		},
		prev: function () {
			if (!this.canSwipe || this.swipers.images.isBeginning) return;
			const [delay, anim] = [1000, 1000];
			this.canSwipe = false;
			Object.values(this.swipers).forEach((swiper) => {
				swiper.slides[swiper.realIndex].classList.add("fade-out");
			});
			initTimer(
				"anim",
				() => {
					Object.values(this.swipers).forEach((swiper) => {
						swiper.slides[swiper.realIndex - 1]?.classList.add("fade-in");
						swiper.slidePrev();
						swiper.slides[swiper.realIndex + 1]?.classList.remove("fade-out");
						initTimer(
							`anim-in-${[...swiper.hostEl.classList].filter((c) =>
								c.includes("-swiper")
							)}`,
							() => {
								swiper.slides[swiper.realIndex].classList.remove("fade-in");
							},
							delay
						);
					});
					partners.updateCounter.bind(partners)();
					document.querySelector(partners.buttons?.[1])?.classList.add('canNext')
					if(partners.swipers.images.realIndex === 0){
						document.querySelector(partners.buttons?.[0])?.classList.remove('canPrev')
					}else{
						document.querySelector(partners.buttons?.[0])?.classList.add('canPrev')
					}
				},
				anim
			);
			initTimer(
				"swipePrev",
				() => {
					this.canSwipe = true;
				},
				delay + anim
			);
		},
		updateCounter: function(){
			if(!this.counter || !this.swipers.texts) return;
			this.counter.innerText = `${this.swipers.texts.realIndex + 1}/${this.swipers.texts.slides.length}`;
		},
		buttons: undefined,
		swipers: undefined,
		pagination: undefined,
		counter: undefined,
	};
	
	const { buttons, prev, next, init, section, direction } = partners;
	
	load(()=>{
		init.bind(partners)()(()=>{
			partners.counter = document.querySelector(`${section} .counter`);
			clickOn(partners.buttons?.[0], prev.bind(partners));
			clickOn(partners.buttons?.[1], next.bind(partners));
	
			partners.updateCounter.bind(partners)();
		})
	})
	
	const titles_partners = new Swiper(`${section} .titles-swiper`, {
		direction: direction,
		speed: 0,
		autoHeight: true,
		slidesPerView: 1,
		pagination: {
			el: `${section} .counter`,
			type: "custom",
			renderCustom: function (swiper, current, total) {
				return `${current}/${total}`;
			},
		},
	});
	
	const images_partners = new Swiper(`${section} .images-swiper`, {
		direction: direction,
		speed: 0,
		slidesPerView: 1,
	});
	
	const texts_partners = new Swiper(`${section} .text-swiper`, {
		direction: direction,
		speed: 0,
		slidesPerView: 1,
		autoHeight: true,
	});
};